import axios from 'axios'
import { create } from 'zustand'

const API_SLUG = 'geo'

interface GeoStore {
  provinces: any[]
  districts: any[]
  subDistricts: any[]
  zipCodes: any[]
  getProvinces: () => Promise<{ success: boolean; data: any }>
  getDistricts: () => Promise<{ success: boolean; data: any }>
  getSubDistricts: () => Promise<{ success: boolean; data: any }>
}

export const useGeoStore = create<GeoStore>(set => ({
  provinces: [],
  districts: [],
  subDistricts: [],
  zipCodes: [],
  getProvinces: async () => {
    return axios
      .get(`/${API_SLUG}/provinces`)
      .then(res => {
        set({ provinces: res.data })
        return { success: true, data: res.data }
      })
      .catch(err => {
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  getDistricts: async () => {
    return axios
      .get(`/${API_SLUG}/amphures`)
      .then(res => {
        set({ districts: res.data })
        return { success: true, data: res.data }
      })
      .catch(err => {
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  getSubDistricts: async () => {
    return axios
      .get(`/${API_SLUG}/tumbons`)
      .then(res => {
        set({
          subDistricts: res.data,
          zipCodes: res.data.map((item: any) => ({
            zip_code: String(item.zip_code),
            amphure_id: item.amphure_id,
          })),
        })
        return { success: true, data: res.data }
      })
      .catch(err => {
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
}))
